import { createSelector } from '@ngrx/store';

import { AppState } from '../app.state';
import { OrganizationState } from './organization.reducer';

export const selectOrganization = createSelector(
  (state: AppState) => state.organization,
  (organization: OrganizationState) => organization
);

export const selectOrganizationPropertiesLoading = createSelector(
  selectOrganization,
  (state: OrganizationState) => state.properties?.loading
);

export const selectOrganizationPropertiesResults = createSelector(
  selectOrganization,
  (state: OrganizationState) => state.properties?.pageOfProperties?.results
);

export const selectOrganizationPropertiesCount = createSelector(
  selectOrganization,
  (state: OrganizationState) => state.properties?.pageOfProperties?.count
);

export const selectOrganizationUrlSlug = createSelector(
  selectOrganization,
  (state: OrganizationState) => state.orgUrlSlug
);

export const selectOrganizationLoading = createSelector(
  selectOrganization,
  (state: OrganizationState) => state.loadingOrg
);

export const selectOrganizationError = createSelector(
  selectOrganization,
  (state: OrganizationState) => state.orgFetchError
);

export const selectOrganizationDetails = createSelector(
  selectOrganization,
  (state: OrganizationState) => state.organization
);
